/** Max recording duration in seconds (~1 min, matches backend MAX_AUDIO_BYTES) */
export const MAX_RECORDING_SECONDS = 60;

const transcribeUrl = () => process.env.REACT_APP_VOICE_TRANSCRIBE_URL!;

export async function transcribeAudio(blob: Blob, language?: string): Promise<{ text: string; durationInSeconds?: number }> {
    const url = transcribeUrl();
    const res = await fetch(url, {
        method: 'POST',
        body: blob,
        headers: { 'Content-Type': blob.type || 'audio/webm', 'Content-Language': language ?? 'en' },
    });
    if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
    const data = await res.json();
    return { text: data.text ?? '', durationInSeconds: data.durationInSeconds };
}
